import React from 'react';
import { getGoogleAuthStatus } from 'api/provider';

interface GoogleAuthStatus {
    connectSwitch: boolean;
    email: string;
    googleCalendarSyncStatus?: boolean;
}

let globalData: GoogleAuthStatus | undefined;

const useGoogleAuthStatus = (): [GoogleAuthStatus | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [val, setVal] = React.useState<GoogleAuthStatus | undefined>(globalData);
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getGoogleAuthStatus();
            if (!result.error) {
                const data = result?.data?.data;
                globalData = { ...data };
                setVal({ ...data });
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!loading) {
            fetchData();
        }
    }, []);

    return [val, loading, fetchData];
};

export default useGoogleAuthStatus;
